import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from "@angular/core";

@Component({
	selector: "app-alert-tooltip",
	templateUrl: "./alert-tooltip.component.html",
	encapsulation: ViewEncapsulation.None
})
export class AlertTooltipComponent implements OnInit {
	constructor() {}

	@Input() message = "";
	@Input() showTooltip = false;
	@Input() location = 0;
	@Input() verticalLocation = 0;
	@Input() position = "relative";
	@Input() color = "#F58022";
	@Input() textColor = "#FFF";
	@Input() timeHidden = 3000;
	@Input() maxWidth = "250px";
	@Input() minWidth = "250px";
	@Input() widthContent = "100%";
	@Input() maxWidthMessage = "250px";
	@Output() changeDisplayTooltip: EventEmitter<boolean> = new EventEmitter();

	ngOnInit() {}

	hideTooltip() {
		setTimeout(_ => {
			this.changeDisplayTooltip.emit(false);
		}, this.timeHidden);
	}
}
